import {
  EMAIL_SUBSCRIBE_SENT,
  EMAIL_SUBSCRIBE_RECEIVED,
} from '../actions/subscribe';

const initialState = {
  pending: false,
  email: null,
  lists: [],
};

export default function subscribe(state = initialState, action) {
  Object.freeze(state);

  switch (action.type) {
    case EMAIL_SUBSCRIBE_SENT:
      return {
        ...state,
        pending: true,
      };
    case EMAIL_SUBSCRIBE_RECEIVED: {
      return {
        ...state,
        pending: false,
        email: action.email,
        lists: [...state.lists, ...action.lists],
      };
    }
    default:
      return state;
  }
}
